import { CompositeMaterialsOverviewComponent } from './../../directory-tree/components/composite-materials-overview/composite-materials-overview.component';
import { AuthService } from './../../../services/auth-service';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MaterialApiService } from '../../../data-transfer/services/material-api-service';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { PathResolveService } from 'src/app/services/path-resolve.service';
import { PROJECT_IMAGES_PATH } from 'src/app/model/paths';
import { MultiMaterialCompositeImportWrapper } from '../../dialogs/selection-dialog-materials/selection-dialog-materials.component';
import { PaginationDataSource } from 'src/app/util/pagination-datasource';

@Component({
  selector: 'app-material-home',
  templateUrl: './material-home.component.html',
  styleUrls: ['./material-home.component.scss']
})
export class MaterialHomeComponent implements OnInit, OnDestroy {

  @ViewChild(CompositeMaterialsOverviewComponent) table!: CompositeMaterialsOverviewComponent;

  materialsDataSource: PaginationDataSource<MultiMaterialCompositeImportWrapper>;
  displayedColumnsMaterials = ['id', 'tracking', 'articleName', 'articleNumber', 'manufacturerName', 'action'];

  isUserValidator = false;
  imageSource = `${PROJECT_IMAGES_PATH}elements/composite_material.svg`;

  private materialsListSubscription?: Subscription;
  private paginationSubscription?: Subscription;

  constructor(
    materialApiService: MaterialApiService,
    private router: Router,
    private authService: AuthService,
  ) {
    this.materialsDataSource = new PaginationDataSource<MultiMaterialCompositeImportWrapper>(x => materialApiService.getMultiMaterialsByPage(x));
  }

  ngOnInit(): void {
    this.isUserValidator = this.authService.isUserValidator();
  }

  createCompositeMaterial() {
    const path = PathResolveService.getCreateMaterialPath(true);
    this.router.navigate([path]);
  }

  ngOnDestroy(): void {
    this.materialsListSubscription?.unsubscribe();
    this.paginationSubscription?.unsubscribe();
  }
}
